import React from 'react';
import Modal from 'react-modal';
import { FaExclamationTriangle, FaTimes } from 'react-icons/fa';
import Spinner from './Spinner';

/**
 * Modal de confirmación reutilizable.
 *
 * Props:
 *  - isOpen, onClose, onConfirm
 *  - title, message
 *  - confirmLabel (default "Confirmar")
 *  - cancelLabel  (default "Cancelar")
 *  - variant: 'danger' | 'primary'  (default 'danger')
 *  - loading: boolean → muestra spinner en el botón confirmar
 */
export default function ConfirmDialog({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmLabel = 'Confirmar',
  cancelLabel = 'Cancelar',
  variant = 'danger',
  loading = false,
}) {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={loading ? undefined : onClose}
      shouldCloseOnOverlayClick={!loading}
      className="bg-surface border border-line rounded-2xl shadow-card mx-4 max-w-md w-full p-0 overflow-hidden relative outline-none"
      overlayClassName="ReactModal__Overlay"
    >
      <div className="px-6 py-5 flex items-start justify-between gap-3">
        <div className="flex items-start gap-3 flex-1">
          <div
            className={`w-10 h-10 rounded-xl grid place-items-center flex-shrink-0 ${
              variant === 'danger'
                ? 'bg-danger/15 text-danger'
                : 'bg-purple/15 text-purple'
            }`}
          >
            <FaExclamationTriangle />
          </div>
          <div className="flex-1 pt-0.5">
            <h3 className="text-base font-semibold text-ink leading-snug">{title}</h3>
            {message && (
              <p className="text-sm text-ink-2 mt-1.5">{message}</p>
            )}
          </div>
        </div>
        {!loading && (
          <button
            onClick={onClose}
            className="text-ink-3 hover:text-ink p-1 transition flex-shrink-0"
            aria-label="Cerrar"
          >
            <FaTimes />
          </button>
        )}
      </div>
      <div className="border-t border-line px-6 py-4 flex justify-end gap-3">
        <button
          onClick={onClose}
          disabled={loading}
          className="si-btn-secondary"
        >
          {cancelLabel}
        </button>
        <button
          onClick={onConfirm}
          disabled={loading}
          className={variant === 'danger' ? 'si-btn-danger' : 'si-btn-primary'}
        >
          {loading && <Spinner size={14} className="mr-2" />}
          {loading ? 'Procesando...' : confirmLabel}
        </button>
      </div>
    </Modal>
  );
}
